import IGridComponent from '../../../components/grid/i-grid.component';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { AppContext } from '../../../app-context';
import { useEffect, useState, useContext } from 'react';
import { getHistory } from '../currency.services';
import { formatDate, isEmptyArray } from '../../common/util.services';
import { PAGE_SIZE } from '../../common/constants';

const HistoryComponent = (props: any) => {

  const columns: GridColDef[] = [
    { field: 'currency', headerName: 'Currency', width: 80 },
    { field: 'rate', headerName: 'Rate', width: 80 },
    { field: 'contingency', headerName: 'Contingency (%)', width: 150 },
    { field: 'date', headerName: 'Date', filterable: false, sortable: false, editable: false,
      valueFormatter: (date: any) => formatDate(date), width: 100
    },
  ];
  
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [history, setHistory] = useState(rows);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    if (isEmptyArray(rows)) {
      getHistory(page, pageSize, props.data.currency, appContext,
        (response: any) => {
          setHistory(response.data.content);
          setTotalRows(response.data.totalElements);
          appContext.setSuccessMessage(response.message);
          appContext.setShowLoader(false);
        }, (error: any) => {
          console.log(error);
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
        });
      }
  }, [page, pageSize]);

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setPageSize(evt.pageSize);
  }

  return <div>
    <IGridComponent title='' showAddBtn={false} rows={history} columns={columns} 
      paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows}
      getRowId={(row: any) => row.rowId}/>
  </div>
}

export default HistoryComponent;